<template>
  <div class="activity-list-card">
    <div class="activity-date">{{initActivity.activityDate | dateFormat('MM月DD日 dddd')}}</div>
    <div class="card-main" :class="{'open-card': isSignIn && open}">
      <div class="card-wrapper" >
        <div class="activity-status" :style="{backgroundColor: ACTIVITY_STATUS[initActivity.status].color}">{{ACTIVITY_STATUS[initActivity.status].name}}</div>
        <div class="activity-time">
          <div class="start-time">{{initActivity.startTime | dateFormat('a HH:mm')}}</div>
          <div class="end-time">{{initActivity.endTime | dateFormat('a HH:mm')}}</div>
        </div>
        <div class="activity-details">
          <div class="activity-top">
            <div class="card-decoration-1" />
            <div class="card-decoration-2" />
            <div class="activity-name">{{initActivity.name}}</div>
            <div class="activity-percentage">{{initActivity.percentage}}%</div>
          </div>
          <div class="activity-bottom">
            <div class="activity-info">{{initActivity.info}}</div>
            <div class="activity-sign-in" v-if="isSignIn" @click="onClick">
              签到
            </div>
          </div>
        </div>
      </div>
      <div class="card-folding">
        <div class="rating-selector-item">
          <div class="activity-fell">在进行{{initActivity.name}}前，你感觉怎么样呢？</div>
          <div class="activity-scoring">
            <rating-selector v-model="initActivity.before" />
          </div>
        </div>
        <div class="rating-selector-item">
          <div class="activity-fell">在完成{{initActivity.name}}后，你的情绪有变化吗，现在你的心情如何呢？</div>
          <div class="activity-scoring">
            <rating-selector v-model="initActivity.after" />
          </div>
        </div>
        <div class="content">
          <textarea placeholder="请输入内容" v-model="initActivity.remark" />
        </div>
        <div class="ok-btn" @click.stop="onSignIn">确认</div>
      </div>
    </div>
  </div>
</template>
<script>

import {ACTIVITY_STATUS} from "@/consts";
import RatingSelector from '../RatingSelector';

export default {
  name: "activityListCard",
  components: {
    RatingSelector
  },
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      open: false,
      initActivity: null,
      ACTIVITY_STATUS
    }
  },
  computed: {
    isSignIn() {
      return this.initActivity.status === '进行中'
    }
  },
  watch: {
    activity: {
      handler() {
        this.init()
      },
      immediate: true
    }
  },
  methods: {
    init() {
      this.initActivity = {
        after: 5,
        before: 5,
        remark: '',
        ...this.activity
      }
    },
    onSignIn() {
      this.$emit("signIn", this.initActivity)
    },
    onClick() {
      this.open = !this.open
    }
  }
}

</script>

<style scoped lang="scss">
.activity-date {
  font-size: 16px;
  font-weight: 500;
  line-height: 33px;
  color: rgba(0, 0, 0, 1);
  text-align: left;
  vertical-align: top;
}
.card-main {
  height: 90px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 30px  rgba(10, 51, 88, 0.11);
  overflow: hidden;
  transition: height .2s;
}
.card-main.open-card {
  height: 91+442px;
}
.card-wrapper {
  display: flex;
  height: 90px;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 14px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 30px rgba(10, 51, 88, 0.11);
}
.activity-status {
  position: absolute;
  top: 0;
  left: 20px;
  width: 41.8px;
  height: 13.2px;
  opacity: 1;
  border-radius: 0 0 5.5px 5.5px;
  background: rgba(0, 122, 255, 1);
  font-size: 8.8px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 13.2px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
}
.activity-time {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 13px;
}
.start-time {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: rgba(0, 0, 0, 1);
}
.end-time {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: rgba(128, 128, 128, 1);
  text-align: left;
  vertical-align: top;
  margin-top: 3px;
}
.activity-details {
  flex: 1;
}
.activity-name {
  flex: 1;
  padding: 0 9px;
  box-sizing: border-box;
  font-size: 12.6px;
  font-weight: 500;
  line-height: 17.64px;
  color: rgba(0, 0, 0, 1);
  text-align: left;
  vertical-align: top;
}
.activity-percentage {
  font-size: 16px;
  font-weight: 500;
  line-height: 22.4px;
  color: rgba(10, 136, 255, 1);
  text-align: left;
  vertical-align: top;
}
.activity-top {
  display: flex;
  align-items: center;
}
.card-decoration-1 {
  width: 1.76px;
  height: 13px;
  opacity: 1;
  border-radius: 61px;
  background: rgba(50, 163, 255, 1);
}
.card-decoration-2 {
  width: 1.76px;
  height: 13px;
  opacity: 1;
  border-radius: 61px;
  background: rgba(0, 74, 255, 1);
}
.activity-bottom{
  display: flex;
  justify-content: space-between;
  margin-top: 3px;
  padding-left: 12px;
  box-sizing: border-box;
}
.activity-info {
  width: 130px;
  font-size: 10px;
  font-weight: 400;
  line-height: 13.26px;
  color: rgba(166, 166, 166, 1);
  text-align: left;
  vertical-align: top;
  white-space: wrap;
  word-break: break-all;
}
.activity-sign-in {
  height: 18px;
  cursor: pointer;
  padding: 2px 15px;
  border-radius: 76px;
  background: rgba(10, 136, 255, 1);
  box-shadow: 0 1px 7px  rgba(10, 136, 255, 0.38);
  font-size: 10px;
  font-weight: 400;
  line-height: 18px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}
.card-folding {
  box-sizing: border-box;
  padding: 20px;
  height: 442px;
}

.activity-fell {
  font-size: 12px;
  font-weight: 400;
  line-height: 15.91px;
  color: rgba(56, 56, 56, 1);
  text-align: left;
  vertical-align: top;
}
.rating-selector-item {
  margin-bottom: 20px;
}
.rating-selector-item:last-child {
  margin-bottom: 0;
}
.content {
  margin-bottom: 12px;
  textarea {
    box-sizing: border-box;
    width: 100%;
    height: 95px;
    padding: 9px 15px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(0, 0, 0, 0.07);
    font-size: 10px;
    font-weight: 400;
    line-height: 23px;
    text-align: left;
    vertical-align: top;
  }
}
.ok-btn {
  cursor: pointer;
  display: block;
  width: 76px;
  margin: 0 auto;
  font-size: 10.13px;
  font-weight: 400;
  letter-spacing: 0.23px;
  line-height: 25px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  border-radius: 12px;
  background: rgba(56, 149, 255, 1);
}
</style>